import { render, staticRenderFns } from "./CancelPatron.vue?vue&type=template&id=c91e29ae&scoped=true&"
import script from "./CancelPatron.vue?vue&type=script&lang=js&"
export * from "./CancelPatron.vue?vue&type=script&lang=js&"
import style0 from "./CancelPatron.vue?vue&type=style&index=0&id=c91e29ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91e29ae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftPatron: require('/home/bitrix/frontend/components/forms/GiftPatron.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default})
